import { SxProps, Theme } from '@mui/material';
import { CrmColors } from '@layouts/pages/CRM/kanban-board/crm-theme';

export const formCardSx = (cc: CrmColors): SxProps<Theme> => ({
    display: 'grid',
    gap: 2,
    p: 2.5,
    border: `1px solid ${cc.border}`,
    borderRadius: '12px',
    bgcolor: cc.cardBg,
});

export const serviceTileSx = (cc: CrmColors, selected: boolean): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'center',
    gap: 1.25,
    px: 1.75,
    py: 1.25,
    cursor: 'pointer',
    userSelect: 'none',
    fontSize: 13.5,
    fontWeight: 700,
    color: cc.textPrimary,
    bgcolor: selected ? cc.accentSoftBg : cc.countBg,
    border: `1px solid ${selected ? cc.accent : cc.borderStrong}`,
    borderRadius: '10px',
    transition: 'border-color 160ms ease',
    '&:hover': { borderColor: selected ? cc.accent : cc.borderHover },
    '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
});
